import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/main-light/page";
import SolutionsPage from "@/pages/solutions/page";
import SolutionDetailPage from "@/pages/solution-detail/page";
import BookerPage from "@/pages/booker/page";
import LeanPage from "@/pages/lean/page";
import NotFound from "@/pages/NotFound";
import AnalyticsPage from "@/pages/analytics/page";
import IntegrationsPage from "@/pages/integrations/page";
import IntegrationDetailPage from "@/pages/integration-detail/page";
import LegacyRedirect from "@/components/feature/LegacyRedirect";

/**
 * Один контент — один адрес. Тема (светлая/тёмная) больше не влияет на URL,
 * поэтому страницы-дубли из прошлого сведены редиректами на канонические пути.
 */
const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/solutions", element: <SolutionsPage /> },
  { path: "/solution/:id", element: <SolutionDetailPage /> },
  { path: "/booker", element: <BookerPage /> },
  { path: "/lean", element: <LeanPage /> },
  { path: "/analytics", element: <AnalyticsPage /> },
  { path: "/integrations", element: <IntegrationsPage /> },
  { path: "/integrations/:slug", element: <IntegrationDetailPage /> },

  /* ── Старые «тёмные» адреса → канонические ── */
  { path: "/dark", element: <LegacyRedirect to="/" /> },
  { path: "/main", element: <LegacyRedirect to="/" /> },
  { path: "/light", element: <LegacyRedirect to="/" /> },
  { path: "/booker-dark", element: <LegacyRedirect to="/booker" /> },
  { path: "/lean-dark", element: <LegacyRedirect to="/lean" /> },
  { path: "/solutions-dark", element: <LegacyRedirect to="/solutions" /> },
  {
    path: "/solution-dark/:id",
    element: <LegacyRedirect to="/solution/{{id}}" />,
  },

  { path: "*", element: <NotFound /> },
];

export default routes;
